module.exports = __webpack_public_path__ + "static/22import-e19fc0d82960a14221b4999b21479fec.png";